//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Api from "../fetch/api";
export default {
  name: "CMS",
  data: () => {
    return {
      loading: true,
      articleInfo: undefined
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.id = this.$route.query.id;
      if (this.id) {
        var that = this;
        this.loading = true;
        Api.getArticle(this.id)
          .then(res => {
            if (res.code === 20000 && res.data) {
              this.articleInfo = res.data;
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    callPhone() {
      window.location.href = "tel://" + this.tel;
    }
  }
};



// WEBPACK FOOTER //
// ./src/page/CMS.vue